import axios from 'axios';
import apiClient from './api';
import type { Shipment, RegisterShipmentRequest } from '../types/shipment';

export const shipmentService = {
  register: async (request: RegisterShipmentRequest): Promise<Shipment> => {
    const response = await apiClient.post<Shipment>('/v1/shipments', request);
    return response.data;
  },

  getById: async (id: number): Promise<Shipment> => {
    const response = await apiClient.get<Shipment>(`/v1/shipments/${id}`);
    return response.data;
  },

  getByActivityGroupId: async (activityGroupId: number): Promise<Shipment | null> => {
    try {
      const response = await apiClient.get<Shipment>('/v1/shipments', {
        params: { activityGroupId },
      });
      return response.data;
    } catch (err: unknown) {
      if (axios.isAxiosError(err) && err.response?.status === 404) return null;
      throw err;
    }
  },

  getByActivityGroupIds: async (activityGroupIds: number[]): Promise<Shipment[]> => {
    if (activityGroupIds.length === 0) return [];
    const response = await apiClient.get<Shipment[]>('/v1/shipments/batch', {
      params: { activityGroupIds: activityGroupIds.join(',') },
    });
    return response.data;
  },

  refreshStatus: async (id: number): Promise<Shipment> => {
    const response = await apiClient.post<Shipment>(`/v1/shipments/${id}/refresh-status`);
    return response.data;
  },

  cancel: async (id: number): Promise<Shipment> => {
    const response = await apiClient.delete<Shipment>(`/v1/shipments/${id}`);
    return response.data;
  },

  /** Marks the shipment CANCELLED locally without calling Nova Poshta — for when Nova Poshta
   * keeps rejecting the cancel call because the ЕН was already voided in its own dashboard. */
  forceCancel: async (id: number): Promise<Shipment> => {
    const response = await apiClient.post<Shipment>(`/v1/shipments/${id}/force-cancel`);
    return response.data;
  },
};
